import { render } from "./DiscountRuleConfig.vue?vue&type=template&id=0df28d63&scoped=true"
import script from "./DiscountRuleConfig.vue?vue&type=script&lang=js"
export * from "./DiscountRuleConfig.vue?vue&type=script&lang=js"

import "./DiscountRuleConfig.vue?vue&type=style&index=0&id=0df28d63&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0df28d63"]])

export default __exports__